// 预定酒店
import hotelIndex from '@/views/travel/hotel/index'

const dyRoutes = Array.from({ length: 24 }, (_, i) => ({
  path: `hotel/dy/index${i + 1}`,
  name: `hotel/dy/Index${i + 1}`,
  component: () => import(`@/views/travel/hotel/dy/index${i + 1}.vue`)
}))
const branchDyRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `hotel/dy/branch/index${i + 1}`,
  name: `hotel/dy/branch/Index${i + 1}`,
  component: () => import(`@/views/travel/hotel/dy/branch/index${i + 1}.vue`)
}))
const mtRoutes = Array.from({ length: 21 }, (_, i) => ({
  path: `hotel/mt/index${i + 1}`,
  name: `hotel/mt/Index${i + 1}`,
  component: () => import(`@/views/travel/hotel/mt/index${i + 1}.vue`)
}))
const branchMtRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `hotel/mt/branch/index${i + 1}`,
  name: `hotel/mt/branch/Index${i + 1}`,
  component: () => import(`@/views/travel/hotel/mt/branch/index${i + 1}.vue`)
}))
const xcRoutes = Array.from({ length: 18 }, (_, i) => ({
  path: `hotel/xc/index${i + 1}`,
  name: `hotel/xc/Index${i + 1}`,
  component: () => import(`@/views/travel/hotel/xc/index${i + 1}.vue`)
}))
const branchXcRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `hotel/xc/branch/index${i + 1}`,
  name: `hotel/xc/branch/Index${i + 1}`,
  component: () => import(`@/views/travel/hotel/xc/branch/index${i + 1}.vue`)
}))

export default {
  path: '/travel',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'hotel/index',
      name: 'hotelIndex',
      component: hotelIndex
    },
    // 预定酒店，开始
    ...dyRoutes,
    ...branchDyRoutes,
    ...mtRoutes,
    ...branchMtRoutes,
    ...xcRoutes,
    ...branchXcRoutes
    // 预定酒店，结束

  ]
}
